/**
 * Rupiah tampilan (integer, pemisah ribuan id-ID). Bukan perhitungan uang — itu tetap server.
 * Tanpa spasi ("Rp22.000"), sama dengan konsol dan kasir (asesmen UI Modul 12).
 */
export const rupiah = (n: number): string => `Rp${Math.round(n).toLocaleString("id-ID")}`

/**
 * Label harga kartu. Produk bervarian menampilkan "Mulai Rp…" dari harga terendah (plan PR5 §0.1);
 * harga final tetap dihitung server setelah pilihan — label ini hanya penanda titik masuk, bukan
 * angka yang ditagih.
 */
export const labelHarga = (basePrice: number, hargaVarian: readonly number[]): string => {
  if (hargaVarian.length === 0) return rupiah(basePrice)
  const min = Math.min(...hargaVarian)
  return hargaVarian.every((h) => h === min) ? rupiah(min) : `Mulai ${rupiah(min)}`
}

/**
 * Produk bisa dipesan tamu di outlet ini? `isAvailable: false` = habis di outlet ini (ADR-0017,
 * keputusan rinci 5): tetap tampil abu-abu "Habis", tanpa tombol tambah. Tak ada medannya (server
 * lama) = tersedia. Produk yang tidak dijual di outlet ini tidak dikirim server sama sekali.
 */
export const bisaDipesan = (p: { isAvailable?: boolean | undefined }): boolean =>
  p.isAvailable !== false
